import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';
import { useAuth0 } from '@auth0/auth0-react';

const fetchHomeForumPosts = async (authenticatedFetch) => {
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/forum/threads?limit=3`);
  if (!response.ok) {
    const errBody = await response.json().catch(() => ({}));
    const msg = errBody?.message || errBody?.error?.message || `Forum request failed (${response.status})`;
    throw new Error(msg);
  }
  const data = await response.json();
  return data.data || [];
};

export const useHomeForumPosts = () => {
  const { authenticatedFetch } = useAuthenticatedApi();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  
  return useQuery({
    queryKey: ['homeForumPosts'],
    queryFn: () => fetchHomeForumPosts(authenticatedFetch),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(2000 * (attemptIndex + 1), 10000),
    enabled: !authLoading && isAuthenticated && !!authenticatedFetch,
  });
};

